import SectionHeader from '../ui/SectionHeader';
import PhotoCarousel from '../ui/PhotoCarousel';
import MotionReveal from '../ui/MotionReveal';
import useAboutContent from '../hooks/useAboutContent';

export default function AboutSection() {
  const { content } = useAboutContent();
  const { title, quote, paragraphs, hobbies, photos } = content;

  return (
    <section id="about" className="section about-section">
      <div className="about-section__shell">
        <div className="about-section__content">
          <MotionReveal>
            <SectionHeader title={title} />
          </MotionReveal>

          <MotionReveal delay={80}>
            <blockquote className="about-section__quote">{quote}</blockquote>
          </MotionReveal>

          <MotionReveal delay={120}>
            <div className="about-section__text">
              {paragraphs.map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))}
              <p className="about-section__hobbies" aria-label="Hobbies and interests">
                {hobbies.join(' · ')}
              </p>
            </div>
          </MotionReveal>
        </div>

        <MotionReveal delay={100} className="about-section__visual" as="figure">
          <PhotoCarousel photos={photos} />
        </MotionReveal>
      </div>
    </section>
  );
}
